import { Lesson } from "@jelly/lesson";
import { slide as slide01 } from "./layouts/principle-01/principle";
import { slide as slide02 } from "./layouts/principle-02/principle";
import task from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "398714f3-97ff-4937-845c-dcdb5e7d9bdd",
  publicId: "5",
  name: "Reverberation time",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [slide01, slide02, task],
};

export default lesson;
